import LoginPage from './LoginPage';

function App() {
  return <LoginPage />;
}

export default App;
